'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './user-insights.routes';

export class UserInsightsComponent {
  constructor(HistoryService, DTOptionsBuilder, Config, $stateParams) {
    'ngInject';

    this.HistoryService = HistoryService;
    this.timezone = Config.getModuleConfig(Config.Modules.General).getClientTimezone();
    this.id = $stateParams.id;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [1, 'desc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Activity per User'
      },{
        extend: 'csv',
        title: 'Activity per User'
      },{
        title: 'Activity per User',
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);

    this.labels = {
      daily: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      hourly: ['12a', '1a', '2a', '3a', '4a', '5a', '6a', '7a', '8a', '9a', '10a', '11a', '12p',
        '1p', '2p', '3p', '4p', '5p', '6p', '7p', '8p', '9p', '10p', '11p'],
      dow: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    };

    this.series = ['Logins', 'Contributions', 'Overall'];

    this.optionsYear = [2016, 2017, 2018, 2019, 2020];
    this.optionsMonth = [{
        value: 0,
        name: 'January'
      },{
        value: 1,
        name: 'February'
      },{
        value: 2,
        name: 'March'
      },{
        value: 3,
        name: 'April'
      },{
        value: 4,
        name: 'May'
      },{
        value: 5,
        name: 'June'
      },{
        value: 6,
        name: 'July'
      },{
        value: 7,
        name: 'August'
      },{
        value: 8,
        name: 'September'
      },{
        value: 9,
        name: 'October'
      },{
        value: 10,
        name: 'November'
      },{
        value: 11,
        name: 'December'
      }];

    var momentNow = moment(new Date());
    this.filterMonth = momentNow.month();
    this.filterYear = momentNow.year();

    this.initView();
  }

  /* Initialized the view by talking to the service
     and fetching all the history data for the selected month  */
  initView() {
    this.resetData(true);

    this.HistoryService.getInsight({year: this.filterYear, month: this.filterMonth, id: this.id}, data => {
      this.rawData = data;
      this.rebuild(data, true);
    });
  }

  /* Updates the view by only showing the users in the chart
     who are selected active in the user table */
  filterView() {
    this.resetData(false);
    this.rebuild(this.rawData, false)
  }

  getFirstUsername() {
    if (this.userTableData.length > 0)
      return this.userTableData[0].name;
    else
      return this.id;
  }

  /* Resets the data for the chart before the initial data fetch and the filter action */
  resetData(initial) {

    if (initial) {
      this.rawData = {};

      this.userIdMapping = {};
      this.userActiveChart = {};
      this.userTableData = [];
    }

    this.displayData = {
      byDay: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      ],
      byHour: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      ],
      byDow: [
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
      ],
      user: {
        logins: {},
        contributions: {},
        total: {}
      }
    };

  }

  /* The actual logic to process the history entries and split them per user and action type */
  rebuild(data, initial) {
    data.forEach(history => {
      var momentCreationDate = moment.tz(history.meta.creationDate, this.timezone);
      var day = momentCreationDate.format("D") - 1; // Because the array starts with 0 and the days with 1
      var hour24 = momentCreationDate.format("H");
      var dow = momentCreationDate.day();

      var name = (!history.meta.creationUser) ? "Unknown" : history.meta.creationUser.lastName + ', ' + history.meta.creationUser.firstName;
      var id = (history.meta.creationUser && history.meta.creationUser._id) ? history.meta.creationUser._id : '';

      if (initial) {
        this.userActiveChart[name] = true;

        if (!this.userIdMapping[name])
          this.userIdMapping[name] = id;
      }

      if (!initial && !this.userActiveChart[name])
        return; // Skip this user

      if (!this.displayData.user.total[name]) {
        this.displayData.user.logins[name] = 0;
        this.displayData.user.contributions[name] = 0;
        this.displayData.user.total[name] = 0;
      }

      if (history.actionType == 'loggedIn') {
        this.displayData.byDay[0][day]++;
        this.displayData.byHour[0][hour24]++;
        this.displayData.byDow[0][dow]++;
        this.displayData.user.logins[name]++;
      } else if (history.actionType == 'created' || history.actionType == 'edited') {
        this.displayData.byDay[1][day]++;
        this.displayData.byHour[1][hour24]++;
        this.displayData.byDow[1][dow]++;
        this.displayData.user.contributions[name]++;
      }

      this.displayData.byDay[2][day]++;
      this.displayData.byHour[2][hour24]++;
      this.displayData.byDow[2][dow]++;
      this.displayData.user.total[name]++;
    });

    if (initial) {
      for (var name in this.displayData.user.total) {
        this.userTableData.push({
          name: name,
          id: this.userIdMapping[name],
          logins: this.displayData.user.logins[name],
          contributions: this.displayData.user.contributions[name],
          total: this.displayData.user.total[name]
        });
      }
    }
  }

}

export default angular.module('conduuApp.userInsights', [uiRouter])
  .config(routes)
  .component('userInsights', {
    template: require('./user-insights.html'),
    controller: UserInsightsComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/superadmin/user-insights/user-insights.component.js